import { useEffect } from 'react';

import useTrackVideoDimensions from 'lib/hooks/useTrackVideoDimensions';

/**
 * This component is an interface to use with useTrackVideoDimensions to support
 * old class components (SelfieScanner)
 */
export const VideoDimensionsTracker = ({
  dimensions,
}: {
  dimensions: { width: number; height: number } | undefined;
}) => {
  const { videoDimensionsUpdated } = useTrackVideoDimensions();

  useEffect(() => {
    if (dimensions) {
      videoDimensionsUpdated(dimensions.width, dimensions.height);
    }
  }, [dimensions, videoDimensionsUpdated]);

  return <></>;
};
